import React from "react";
import i18n from "../../../language/i18n";
import { typeTagLabel, type ProductTypeTag } from "../../../services/typeTagApi";
import "./typeTagFilter.css";

export type TypeTagOption = ProductTypeTag & { count: number };

type Props = {
  options: TypeTagOption[];
  selected: string[];
  onToggle: (id: string) => void;
  onClear: () => void;
};

/** Filter chips for a catalogue: the types its pieces carry, with how many pieces each covers. Hidden when no piece is tagged. */
const TypeTagFilterBar: React.FC<Props> = ({ options, selected, onToggle, onClear }) => {
  if (!options.length) return null;
  const language = i18n.language;
  return (
    <div className="hkp-tag-filter" role="group" aria-label="Filter by type">
      {options.map((tag) => {
        const on = selected.includes(tag.id);
        return (
          <button
            key={tag.id}
            type="button"
            className={`hkp-tag-chip${on ? " is-active" : ""}`}
            aria-pressed={on}
            onClick={() => onToggle(tag.id)}
          >
            {typeTagLabel(tag, language)}
            <span className="hkp-tag-chip-count">{tag.count}</span>
          </button>
        );
      })}
      {selected.length ? (
        <button type="button" className="hkp-tag-clear" onClick={onClear}>
          Clear
        </button>
      ) : null}
    </div>
  );
};

export default TypeTagFilterBar;
